var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1",
    viewBox: "0 0 250 143.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_45);}.cls-2{fill:url(#Degradado_sin_nombre_45-2);}.cls-3{fill:url(#Degradado_sin_nombre_45-3);}.cls-4{fill:url(#Degradado_sin_nombre_45-4);}.cls-5{fill:url(#Degradado_sin_nombre_45-5);}.cls-6{fill:url(#Degradado_sin_nombre_45-6);}.cls-7{fill:url(#Degradado_sin_nombre_45-7);}.cls-8{fill:url(#Degradado_sin_nombre_45-8);}.cls-9{fill:url(#Degradado_sin_nombre_45-9);}.cls-10{fill:url(#Degradado_sin_nombre_45-10);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45",
    x1: 215.37,
    y1: -73.36,
    x2: -6.58,
    y2: 145.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24473a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1d3c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091f13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-2",
    x1: 209.86,
    y1: -78.94,
    x2: -12.09,
    y2: 140.34,
    xlinkHref: "#Degradado_sin_nombre_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-3",
    x1: 247.67,
    y1: -40.67,
    x2: 25.71,
    y2: 178.6,
    xlinkHref: "#Degradado_sin_nombre_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-4",
    x1: 214.34,
    y1: -74.41,
    x2: -7.61,
    y2: 144.87,
    xlinkHref: "#Degradado_sin_nombre_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-5",
    x1: 234.84,
    y1: -53.66,
    x2: 12.89,
    y2: 165.62,
    xlinkHref: "#Degradado_sin_nombre_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-6",
    x1: 248.21,
    y1: -40.12,
    x2: 26.26,
    y2: 179.16,
    xlinkHref: "#Degradado_sin_nombre_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-7",
    x1: 263.19,
    y1: -24.96,
    x2: 41.23,
    y2: 194.31,
    xlinkHref: "#Degradado_sin_nombre_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-8",
    x1: 279.88,
    y1: -8.06,
    x2: 57.93,
    y2: 211.22,
    xlinkHref: "#Degradado_sin_nombre_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-9",
    x1: 306.45,
    y1: 18.83,
    x2: 84.5,
    y2: 238.11,
    xlinkHref: "#Degradado_sin_nombre_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_45-10",
    x1: 318.86,
    y1: 31.39,
    x2: 96.91,
    y2: 250.66,
    xlinkHref: "#Degradado_sin_nombre_45"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WiseWay-Logo-x250&#x41C;&#x43E;&#x43D;&#x442;&#x430;&#x436;&#x43D;&#x430;&#x44F; &#x43E;&#x431;&#x43B;&#x430;&#x441;&#x442;&#x44C; 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.74,74.18q0,3.12.29,6.16H100.7c-.14-1.76-.22-3.55-.24-5.35h0A73,73,0,0,0,72.87,29.2V17.79a82.39,82.39,0,0,1,30.31,34.8q1.06-4,2.5-7.86a72.58,72.58,0,0,1,6.07,11.92,73.7,73.7,0,0,0-2,17.15C109.73,73.92,109.73,74.05,109.74,74.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.52,0V10.08a72.89,72.89,0,0,0-39.9,42.71,72.84,72.84,0,0,0-10.42-21.4,72.81,72.81,0,0,0-10.42,21.4,72.91,72.91,0,0,0-39.9-42.72V0a81.86,81.86,0,0,1,39.37,31.14,82.68,82.68,0,0,1,11-14.37,82.57,82.57,0,0,1,11,14.37A81.83,81.83,0,0,1,173.52,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.52,17.79V29.2A73,73,0,0,0,145.93,75h0c0,1.8-.11,3.58-.24,5.35h-9.32q.27-3.06.29-6.18h0c0-.12,0-.25,0-.37a73.71,73.71,0,0,0-2-17.15,72.45,72.45,0,0,1,6.07-11.92q1.44,3.84,2.5,7.86A82.38,82.38,0,0,1,173.52,17.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.09,97.06,45.41,132.77H36.53l-7.86-24.18-8.11,24.18H11.73L0,97.06H8.57l8.06,25.1,8.42-25.1H32.7l8.16,25.31,8.32-25.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62,100.22a4.32,4.32,0,0,1,0-6.33,5,5,0,0,1,3.57-1.28,5.18,5.18,0,0,1,3.57,1.22,3.93,3.93,0,0,1,1.38,3.06,4.33,4.33,0,0,1-1.38,3.29,5,5,0,0,1-3.57,1.3A5,5,0,0,1,62,100.22Zm-.41,5.1h8v27.45h-8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.54,132.34a17.47,17.47,0,0,1-5.2-2.12L77,124.51a16.65,16.65,0,0,0,4.44,1.91,18.59,18.59,0,0,0,5.1.74q5.05,0,5.05-2.5A1.77,1.77,0,0,0,90.2,123a20.46,20.46,0,0,0-4.23-.87,40.66,40.66,0,0,1-5.56-1.17,8.62,8.62,0,0,1-3.8-2.35,6.67,6.67,0,0,1-1.61-4.8,7.51,7.51,0,0,1,1.51-4.62A9.68,9.68,0,0,1,80.89,106a18.74,18.74,0,0,1,6.81-1.12,26.74,26.74,0,0,1,5.79.64,16.23,16.23,0,0,1,4.77,1.76L95.61,113a15.85,15.85,0,0,0-7.91-2,8,8,0,0,0-3.83.71,2.1,2.1,0,0,0-1.28,1.84A1.82,1.82,0,0,0,84,115.27a24.38,24.38,0,0,0,4.39,1,47,47,0,0,1,5.51,1.2,8.29,8.29,0,0,1,3.72,2.32,6.59,6.59,0,0,1,1.58,4.69A7.25,7.25,0,0,1,97.65,129a9.77,9.77,0,0,1-4.46,3.09,19.89,19.89,0,0,1-7,1.1A26.68,26.68,0,0,1,79.54,132.34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.82,121.29H110.05a6.46,6.46,0,0,0,2.65,4,8.78,8.78,0,0,0,5.2,1.48,10.53,10.53,0,0,0,3.8-.64,9.22,9.22,0,0,0,3.09-2l4.24,4.59q-3.88,4.44-11.33,4.44a17.91,17.91,0,0,1-8.21-1.81,13.27,13.27,0,0,1-5.51-5A13.84,13.84,0,0,1,102,119a14,14,0,0,1,1.91-7.27,13.41,13.41,0,0,1,5.26-5.05,16.27,16.27,0,0,1,14.77-.08,12.68,12.68,0,0,1,5.13,5,14.84,14.84,0,0,1,1.86,7.53Q131,119.3,130.82,121.29Zm-18.62-8.83a6.52,6.52,0,0,0-2.24,4.18h13.52a6.58,6.58,0,0,0-2.24-4.16,6.71,6.71,0,0,0-4.49-1.56A6.85,6.85,0,0,0,112.19,112.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M189.8,97.06l-11.68,35.71h-8.88l-7.86-24.18-8.11,24.18h-8.83L132.7,97.06h8.57l8.06,25.1,8.42-25.1h7.65l8.16,25.31,8.32-25.31Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M212.65,108q3.42,3,3.42,9.16v15.66h-7.45v-3.42q-2.25,3.83-8.37,3.83a13,13,0,0,1-5.48-1.07,8.18,8.18,0,0,1-3.55-3,7.7,7.7,0,0,1-1.22-4.29,7.15,7.15,0,0,1,2.88-6q2.88-2.19,8.9-2.19h6.33a5.08,5.08,0,0,0-1.58-4,7,7,0,0,0-4.74-1.4,13.86,13.86,0,0,0-4.31.69,11.4,11.4,0,0,0-3.6,1.86L191,108.23a17.25,17.25,0,0,1,5.38-2.45,24.13,24.13,0,0,1,6.45-.87Q209.23,104.91,212.65,108Zm-6.79,18.93a5.17,5.17,0,0,0,2.25-2.78v-2.81h-5.46q-4.9,0-4.9,3.21a2.86,2.86,0,0,0,1.2,2.42,5.4,5.4,0,0,0,3.29.89A6.93,6.93,0,0,0,205.87,126.88Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M250,105.32l-12.4,29.13q-1.89,4.74-4.67,6.68a11.44,11.44,0,0,1-6.71,1.94,13.94,13.94,0,0,1-4.23-.66,9.34,9.34,0,0,1-3.42-1.84l2.91-5.66a6.84,6.84,0,0,0,2.12,1.28,6.59,6.59,0,0,0,2.37.46,4.21,4.21,0,0,0,2.65-.79,6.72,6.72,0,0,0,1.84-2.63l.1-.25-11.89-27.65h8.21l7.7,18.62,7.76-18.62Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWise);
export default __webpack_public_path__ + "static/media/wise.32a0152b7dab2b3787d53fa7f434d635.svg";
export { ForwardRef as ReactComponent };